// @ts-nocheck
/**
 * @generated
 * @file HomeHeaderNew (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Grid from "./webflow_modules/Layout/components/Grid";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";
import * as _interactions from "./webflow_modules/interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e":{"id":"e","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"4900e0fa-0f5d-9409-3d6b-547ac5d6a411","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"4900e0fa-0f5d-9409-3d6b-547ac5d6a411","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1773151916769},"e-2":{"id":"e-2","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-2","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"193a056f-1efb-1bec-4291-df43e6609cd1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"193a056f-1efb-1bec-4291-df43e6609cd1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-2-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1773157818052},"e-3":{"id":"e-3","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-3","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"42aec6e9-9fac-12e6-3b0c-a2d03f3123b2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":[{"continuousParameterGroupId":"a-3-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1774017223946}},"actionLists":{"a":{"id":"a","title":"SoT Impact Scroll 5","continuousParameterGroups":[{"id":"a-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":50,"actionItems":[{"id":"a-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}]}],"createdOn":1712155236371},"a-2":{"id":"a-2","title":"SoT Impact Scroll 6","continuousParameterGroups":[{"id":"a-2-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":50,"actionItems":[{"id":"a-2-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-2-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-2-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-2-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}]}],"createdOn":1712155236371},"a-3":{"id":"a-3","title":"SoT Impact Scroll 7","continuousParameterGroups":[{"id":"a-3-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":50,"actionItems":[{"id":"a-3-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-3-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-3-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-3-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}]}],"createdOn":1712155236371}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

/**
 * Props for {@link HomeHeaderNew}
 */
export type HomeHeaderNewProps = {
  link1?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link2?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  text1?: React.ReactNode;
  text2?: React.ReactNode;
  text4?: React.ReactNode;
  text5?: React.ReactNode;
  text6?: React.ReactNode;
  title?: React.ReactNode;
};

/**
 * HomeHeaderNew
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function HomeHeaderNew({
  link1 = {
    href: "/connect",
  },

  link2 = {
    href: "/business",
  },

  text1 = (
    <>
      {
        "Support a carefully selected mix of restoration projects that make the biggest difference."
      }
      <br />
    </>
  ),
  text2 = (
    <>
      {
        "Follow the impact you’re making: fully tracked with field updates, imagery and GPS."
      }
      <br />
    </>
  ),
  text4 = "For business",
  text5 = "FORNATUREPROJECTS",
  text6 = (
    <>
      {"More than "}
      <br />
    </>
  ),
  title = "Restore the Planet From Forest to Reef",
}: HomeHeaderNewProps) {
  _interactions.useInteractions(_interactionsData);

  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"hero-header-wrapper"}
        data-w-id={"193a056f-1efb-1bec-4291-df43e6609cd1"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <Block className={"hero-background"} tag={"div"}>
          <Block className={"hero-overlay"} tag={"div"}>
            <Grid className={"hero-grid-mobile"} tag={"div"}>
              <Block
                className={"impact-media-row-1"}
                id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cd5-e6609cd1"}
                tag={"div"}
              >
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cd6-e6609cd1"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84640_main-large%20(1)7.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cd8-e6609cd1"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84639_PF-barrier.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/CG-Nursery_compressed2.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cdc-e6609cd1"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8463d_65e042cdf7b047d56a27f55c_BJF-Nursery.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/BJF-Nursery_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
              </Block>
              <Block
                className={"impact-media-row-2"}
                id={"w-node-_193a056f-1efb-1bec-4291-df43e6609ce0-e6609cd1"}
                tag={"div"}
              >
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609ce1-e6609cd1"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84639_PF-barrier.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/PF-barrier_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609ce5-e6609cd1"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84644_main-large%20(1)4.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609ce7-e6609cd1"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8463b_65e0425e38b64e3bbbcff49b_Mos-Kelp.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/Mos-Kelp_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
              </Block>
            </Grid>
            <Grid className={"hero-grid-desktop"} tag={"div"}>
              <Block
                className={"impact-media-column-1"}
                id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cec-e6609cd1"}
                tag={"div"}
              >
                <Block className={"impact-media-block"} tag={"div"}>
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84640_main-large%20(1)7.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cef-e6609cd1"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8464c_image%209.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cf1-e6609cd1"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84644_main-large%20(1)4.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
              </Block>
              <Block
                className={"impact-media-column-2"}
                id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cf3-e6609cd1"}
                tag={"div"}
              >
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cf4-e6609cd1"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b16734e8a597a84632_PHOTO-2023-03-16-12-21-29.webp"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cf6-e6609cd1"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8463d_65e042cdf7b047d56a27f55c_BJF-Nursery.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/BJF-Nursery_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cfa-e6609cd1"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84648_image%206.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
              </Block>
              <Block
                className={"hero-grid-mask"}
                id={"w-node-_193a056f-1efb-1bec-4291-df43e6609cfc-e6609cd1"}
                tag={"div"}
              />
            </Grid>
            <HtmlEmbed
              content={
                '<style>\n  body {\n    margin: 0;\n  }\n</style>\n<script>\n(function () {\n  function q(className) {\n    return \'[class*="\' + className + \'"]\';\n  }\n  function initAnimations() {\n    var wrapper = document.querySelector(q("hero-header-wrapper"));\n    if (!wrapper) return;\n    if (wrapper.dataset.initialized) return;  // ← ADDED\n    wrapper.dataset.initialized = \'true\';     // ← ADDED\n    var col1 = wrapper.querySelector(q("impact-media-column-1"));\n    var col2 = wrapper.querySelector(q("impact-media-column-2"));\n    var row1 = document.querySelector(q("impact-media-row-1"));\n    var row2 = wrapper.querySelector(q("impact-media-row-2"));\n    var elements = [col1, col2, row1, row2];\n    elements.forEach(function(el) {\n      if (el) {\n        el.style.transition = "transform 0.6s ease-out";\n        el.style.willChange = "transform";\n      }\n    });\n    var isTicking = false;\n    function updateScroll() {\n      var rect = wrapper.getBoundingClientRect();\n      var windowHeight = window.innerHeight;\n      var totalDist1 = windowHeight + rect.height;\n      var scrolled1 = windowHeight - rect.top;\n      var p1 = Math.max(0, Math.min(1, scrolled1 / totalDist1));\n      var totalDist2 = windowHeight + 700;\n      var scrolled2 = windowHeight - rect.top;\n      var p2 = Math.max(0, Math.min(1, scrolled2 / totalDist2));\n      if (col1) {\n        var y1 = 50 - (100 * p1);\n        col1.style.transform = \'translateY(\' + y1 + \'px)\';\n      }\n      if (col2) {\n        var y2 = -50 + (100 * p1);\n        col2.style.transform = \'translateY(\' + y2 + \'px)\';\n      }\n      if (row1) {\n        var x1 = -130 + (130 * p2);\n        row1.style.transform = \'translateX(\' + x1 + \'px)\';\n      }\n      if (row2) {\n        var x2 = -30 - (170 * p2);\n        row2.style.transform = \'translateX(\' + x2 + \'px)\';\n      }\n      isTicking = false;\n    }\n    function onScroll() {\n      if (!isTicking) {\n        window.requestAnimationFrame(updateScroll);\n        isTicking = true;\n      }\n    }\n    window.addEventListener("scroll", onScroll, { passive: true });\n    window.addEventListener("resize", onScroll, { passive: true });\n    updateScroll();\n  }\n  if (document.readyState === "complete") {\n    initAnimations();\n  } else {\n    window.addEventListener("load", initAnimations);\n  }\n})();\n</script>'
              }
            />
          </Block>
        </Block>
        <Block className={"hero-content"} tag={"div"}>
          <BlockContainer
            className={"container-main"}
            grid={{
              type: "container",
            }}
            tag={"div"}
          >
            <Block className={"hero-flex-box"} tag={"div"}>
              <Block className={"hero-flex-block-inner"} tag={"div"}>
                <Heading className={"h1"} tag={"h1"}>
                  {title}
                </Heading>
                <Block className={"hero-body"} tag={"div"}>
                  <Block className={"hero-main-text"} tag={"div"}>
                    <Paragraph className={"body-medium"}>{text1}</Paragraph>
                    <Paragraph className={"body-medium"}>{text2}</Paragraph>
                  </Block>
                </Block>
                <Block className={"hero-buttons"} tag={"div"}>
                  <Link
                    button={true}
                    className={"button-yellow-full"}
                    options={link1}
                  >
                    {text5}
                  </Link>
                  <Link
                    button={true}
                    className={"button-black-empty hero"}
                    options={link2}
                  >
                    {text4}
                  </Link>
                </Block>
                <Block
                  className={"hero-link-to-supporters-wrapper"}
                  tag={"div"}
                >
                  <Block className={"supporter-image-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"supporter-image"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84651_1581618432715.jpeg"
                      }
                      width={"auto"}
                    />
                    <Image
                      alt={""}
                      className={"supporter-image secondary"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b16734e8a597a8462b_1683881452634.jpeg"
                      }
                      width={"auto"}
                    />
                    <Image
                      alt={""}
                      className={"supporter-image third"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8464f_1705659471882.jpeg"
                      }
                      width={"auto"}
                    />
                  </Block>
                  <Block className={"body-small"} tag={"div"}>
                    {text6}
                  </Block>
                </Block>
              </Block>
            </Block>
          </BlockContainer>
        </Block>
      </Section>
    </div>
  );
}
